export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS';
export const ADD_WRITER_SUCCESS = 'ADD_WRITER_SUCCESS';
export const ADD_DESIGN_SUCCESS = 'ADD_DESIGN_SUCCESS';
export const ADD_ADMIN_SUCCESS = 'ADD_ADMIN_SUCCESS';
